import { Navigate } from 'react-router-dom';

import { useIsAdmin, useIsCabinet, useIsHr, useIsManager, useIsTabel } from '~modules/auth/model';
import { routerKeys } from '~shared/router';

export function CabinetIndexPage() {
	const isManager = useIsManager();
	const isAdmin = useIsAdmin();
	const isCabinet = useIsCabinet();
	const isTabel = useIsTabel();
	const isHr = useIsHr();

	if (isManager) return <Navigate to={routerKeys.manager.root()} />;
	if (isAdmin) return <Navigate to={routerKeys.cabinet.admin.root()} />;
	if (isTabel || isHr) return <Navigate to={routerKeys.tabel.root()} />;
	if (!isCabinet) return <Navigate to={routerKeys.session()} />;

	return <Navigate to={routerKeys.denied()} />;
}
